export enum ReceiveOperationalPlanType {
    FSPD = 0,
    CAPTAIN = 1
}